/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 自建地点标签，点击显示说明气泡。不用 Ant Design Popover，避免 html2canvas 截图时无法绘制。
 */

import React, { useState, useRef, useEffect } from 'react'

const POPOVER_CONTENT = '该地点为用户自定义地点'

// 信息图标 SVG 转为 data URL，保证下载报告时 html2canvas 能绘制
const INFO_ICON_SVG = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="5" stroke="#237b19" stroke-width="1.2" fill="none"/><path d="M6 5v3M6 4.5v-.5" stroke="#237b19" stroke-width="1.2" stroke-linecap="round"/></svg>`
const INFO_ICON_DATA_URL = `data:image/svg+xml,${encodeURIComponent(
  INFO_ICON_SVG
)}`

export default function SelfBuiltLocationTag() {
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (!open) return
    const onDocClick = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setOpen(false)
      }
    }
    document.addEventListener('click', onDocClick, true)
    return () => document.removeEventListener('click', onDocClick, true)
  }, [open])

  return (
    <span className="location-tag-wrapper" ref={wrapperRef}>
      <span
        className="location-tag-solid"
        role="button"
        tabIndex={0}
        onClick={(e) => {
          e.stopPropagation()
          setOpen((v) => !v)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            setOpen((v) => !v)
          }
        }}
      >
        自建地点
        <span className="location-tag-icon" aria-hidden>
          <img src={INFO_ICON_DATA_URL} width={12} height={12} alt="" />
        </span>
      </span>
      {open && <div className="location-tag-bubble">{POPOVER_CONTENT}</div>}
    </span>
  )
}
